import { Text } from '~/commonComponents';

export const GotReferredSection = () => {
  return (
    <>
      <Text color="primary_500" bold fontSize={22} paddingTop={32}>
        Got Referred? Enter Their Link to{' '}
        <Text color="success_400" bold fontSize={22}>
          Start Earning
        </Text>
      </Text>

      <Text textAlign="center" color="neutral_500" marginTop={20}>
        If a colleague or professional referred you, enter their link below. <br />
        Once you both complete your first shift, you&apos;ll each receive a <br />
        reward as a thank you from GoTu!
      </Text>
    </>
  );
};
